import './App.css';
import { BrowserRouter } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import AuthenticatedApp from './firebaseAuth/AuthenticatedApp';
import UnauthenticatedApp from './firebaseAuth/UnauthenticatedApp';
import { Spinner } from 'evergreen-ui';
import { useAuth } from './customAuth/authStateHook';
import { AuthProvider } from './customAuth/authContext';

function AppContent() {
  const { user, loading, isTokenSynced } = useAuth();

  if (loading) {
    return <div className='appReload'><Spinner /></div>;
  }

  return (
    <div className='app'>
      <BrowserRouter>
        {user && isTokenSynced ? <AuthenticatedApp userEmail={user.email} /> : <UnauthenticatedApp />}
      </BrowserRouter>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
